import React, { useEffect } from 'react';
import { getApiUrl } from '../../config';

const VERSION_POLL_INTERVAL_MS = 30_000;

interface VersionResponse {
  version?: string;
}

const VersionMonitor: React.FC = () => {
  useEffect(() => {
    let stopped = false;
    let reloadRequested = false;
    let loadedVersion: string | null = null;

    const checkVersion = async () => {
      if (stopped || reloadRequested) {
        return;
      }

      try {
        const response = await fetch(`${getApiUrl('version')}?t=${Date.now()}`, {
          cache: 'no-store',
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) return;

        const body = await response.json() as VersionResponse;
        const availableVersion = body.version?.trim();

        if (!availableVersion || availableVersion === 'unknown') return;
        if (loadedVersion === null) {
          loadedVersion = availableVersion;
        } else if (availableVersion !== loadedVersion) {
          reloadRequested = true;
          window.location.reload();
        }
      } catch {
        // A transient deployment or network failure will be retried on the next poll.
      }
    };

    const interval = window.setInterval(checkVersion, VERSION_POLL_INTERVAL_MS);
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') void checkVersion();
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    void checkVersion();

    return () => {
      stopped = true;
      window.clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return null;
};

export default VersionMonitor;
